
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation/nr-loading-animation.vue'
import { mapMutations, mapActions, mapState } from 'vuex'
import helpers from '../../../utils/helpers.js'

interface StaffHours {
  // eslint-disable-next-line camelcase
  department_id: number | null
  // eslint-disable-next-line camelcase
  description: string
  hours: number
  minutes: number
  // eslint-disable-next-line camelcase
  staff_hour: string
  // eslint-disable-next-line camelcase
  staff_id: number
  // eslint-disable-next-line camelcase
  staff_name: string
  id: number
}

export default {
  components: {
    NrIconButton,
    NrModal,
    NrTooltip,
    NrLoadingAnimation
  },
  props: {
    staffCost: {
      required: false,
      type: String,
      default() {
        return ''
      }
    },
    totalStaffHours: {
      required: false,
      type: String,
      default() {
        return ''
      }
    }
  },

  computed: {
    ...mapState(['currentUser']),
    ...mapState('request_show', [
      'request',
      'requestStaffHours',
      'filteredRequestLoading',
      'selectedStaffHour',
      'activeModal'
    ]),
    deleteStaffHourConfirmationText(): string {
      return `You are about to remove staff time logged for this user.
      This action cannot be undone. Do you want to continue?`
    }
  },

  methods: {
    ...mapActions('request_show', [
      'fetchRequestStaffHours',
      'processStaffHour'
    ]),

    ...mapMutations('request_show', ['setSelectedStaffHour', 'setActiveModal']),

    clearSelection(): void {
      this.setActiveModal(null)
      this.selectedInvoice = []
    },

    processDeleteClick(staffHour: StaffHours, modalName: string) {
      this.setSelectedStaffHour(staffHour)
      this.setActiveModal(modalName)
    },

    processEditClick(hour: StaffHours) {
      this.$emit('set-staff-time-for-edit', hour)
      this.setActiveModal('editStaffTime')
    },

    processDeleteStaffSubmit(): void {
      const payload = {
        id: this.selectedStaffHour.id,
        request_id: this.request.pretty_id,
        action: 'delete',
        method: 'delete'
      }
      this.processStaffHour(payload).then(() => {
        this.clearSelection()
      })
      this.setSelectedStaffHour({})
      this.setActiveModal(null)
    },

    formatCost(cost: number, maximumFractionDigits: number = 2): string {
      return helpers.formatCost(cost, maximumFractionDigits)
    }
  }
}
